import {FC, SVGProps} from 'react';
import {
	IndividualEntrepreneurCharacterIcon,
	IndividualEntrepreneurCharacterIconBig,
	NotSelfEmployedCharacterIcon,
	NotSelfEmployedCharacterIconBig,
	SelfEmployedCharacterIcon,
	SelfEmployedCharacterIconBig,
} from 'shared/assets/icons';
import {RegistrationWorkStatus} from './types';

export const WORK_STATUS_ICONS: Record<RegistrationWorkStatus, FC<SVGProps<SVGSVGElement>>> = {
	self_employment: SelfEmployedCharacterIcon,
	individual: NotSelfEmployedCharacterIcon,
	individual_entrepreneur: IndividualEntrepreneurCharacterIcon,
};

export const WORK_STATUS_ICONS_FULL_SCREEN: Record<RegistrationWorkStatus, FC<SVGProps<SVGSVGElement>>> = {
	self_employment: SelfEmployedCharacterIconBig,
	individual: NotSelfEmployedCharacterIconBig,
	individual_entrepreneur: IndividualEntrepreneurCharacterIconBig,
};
